// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"styles_imgContainer__1wh6u","gridContainer":"styles_gridContainer__1wdz8","staffList":"styles_staffList__SU-6i","itemText":"styles_itemText__1MSDl"};